import React, { FC, HTMLAttributes } from 'react';
import clsx from 'clsx';

import { Typography } from '@common/styles';

import { useProductCardContext } from '../../../context/ProductCardContext';
import { Root } from './StoreName.styled';

/**
 * 스토어 명 컴포넌트
 */
export const StoreName: FC<React.PropsWithChildren<HTMLAttributes<HTMLParagraphElement>>> = ({ className, ...rest }) => {
  const { shop_name } = useProductCardContext();
  return (
    <Root {...rest} className={clsx(className, Typography.CAPTION_12_SEMIBOLD)}>
      {shop_name}
    </Root>
  );
};
